import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, HStack, ModalBody, ModalFooter, ModalHeader, VStack } from '@chakra-ui/react';
import { MdCancel, MdCheck } from 'react-icons/md';
import DynamicFormField from '@components/DynamicFormField/DynamicFormField';
import { ALERT_STATUS_TYPE } from '@constants';
import { setAlert } from '@store/actions/alertActions';


const ActionButton = ({ onClick, isLoading, isDisabled, colorScheme, leftIcon, children }) => (
  <Button
    variant={'outline'}
    colorScheme={colorScheme}
    size={'sm'}
    border={'2px solid'}
    borderRadius={'xl'}
    isDisabled={isDisabled}
    isLoading={isLoading}
    onClick={onClick}
    leftIcon={leftIcon}
  >
    {children}
  </Button>
);


const CreatePotModalV2 = ({
   title,
   onClose,
   onSubmit,
   fields,
   formData,
   setFormData,
   isLoading
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const initialData = fields.reduce((acc, field) => {
      acc[field.name] = field.value;
      return acc;
    }, {});

    setFormData(initialData);
  }, []);

  const handleInputChange = ({ target: { name, value, type, checked } }) => {
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : type === "number" ? Number(value) : value,
    }));
  };

  const handleFormSubmit = async () => {
    const isValid = fields.every(field => {
      if (field.isRequired) {
        return formData[field.name] !== undefined && formData[field.name] !== null && formData[field.name] !== '';
      }
      return true;
    });

    if (!isValid) {
      dispatch(
        setAlert({
          title: 'Please fill all the required fields',
          status: ALERT_STATUS_TYPE.INFO
        })
      );
      return;
    }

    await onSubmit(formData);
    onClose();
  };

  return (
    <>
      <ModalHeader>{title}</ModalHeader>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          await handleFormSubmit();
        }}
      >
        <ModalBody>
          <VStack alignItems={'stretch'} w={'full'}>
            {fields?.map((field) => (
              <DynamicFormField
                key={field?.name}
                fieldConfig={field}
                data={formData}
                handleChange={handleInputChange}
              />
            ))}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack>
            <ActionButton
              onClick={onClose}
              isDisabled={isLoading}
              isLoading={false}
              colorScheme="red"
              leftIcon={<MdCancel />}
            >
              Cancel
            </ActionButton>
            <ActionButton
              onClick={handleFormSubmit}
              isLoading={isLoading}
              isDisabled={isLoading}
              colorScheme="brand"
              leftIcon={<MdCheck />}
            >
              Submit
            </ActionButton>
          </HStack>
        </ModalFooter>
      </form>
    </>
  );
};

export default CreatePotModalV2;
